/**
 * Landing pública de Neurografy.
 *
 * Se sirve como HTML estático desde /home/ y se muestra en un iframe a pantalla
 * completa: la landing trae sus propios estilos globales (define `body`), que
 * chocarían con Tailwind si se montara dentro de la app.
 */
export default function Home() {
  return (
    <iframe
      src="/home/index.html"
      title="Neurografy"
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: 0,
      }}
    />
  );
}
